import './App.css';
import React, {useState} from 'react';



function App() {

    const [numx, setNumx] = useState(0);
    const [numy, setNumy] = useState(0);

    const randomNumberInRange = (min, max) => {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    const handleClick = () => {
        let x = randomNumberInRange(1, 20);
        let y = randomNumberInRange(1, 20);

        while (y === x) {
            y = randomNumberInRange(1, 20);
        }

        setNumx(x);
        setNumy(y);
    }

    return (




    <div className="Background">
      <div className="Roller">
        <h1>TI4 LADZ</h1>
        <button className="Button" onClick={handleClick}>ROLL OBJECTIVES</button>
      </div>


        <div className="Objectives">
            <div className="row">
          <div className="column">
              <img src={require("./images/"+ numx + ".jpg")} width="100%" alt="Objective 1" />
          </div>

          <div className="column">
              <img src={require("./images/"+ numy + ".jpg")} width="100%" alt="Objective 2" />
          </div>
            </div>
        </div>
    </div>
  );
}

export default App;
